import DashboardComponent from './Dashboard';

export const Dash = DashboardComponent;
